import type { ProductSettings } from "@wbly/data-storefront";
import { replaceText } from "@wbly/common";
import type { Hit } from "instantsearch.js";
import type { Marketplace } from "@wbly/common";
import type { AlgoliaProduct } from "../../types/algolia-product";
import { getProductUrl } from "../../util/get-product-url";
import type { ProductCardProps } from "../ProductCard";

export function formatAgeRange(
  productSettings: ProductSettings,
  min: string,
  max: string
) {
  if (!max) {
    return replaceText(productSettings.ageMinLabel, { min });
  }
  return replaceText(productSettings.ageRangeLabel, { min, max });
}

export function formatLabel(productSettings: ProductSettings) {
  return replaceText(productSettings.priceFromLabel, {
    price: "",
    // This is not a smart solution, but I wanted to avoid any Prismic update
    // for this logic as we are redoing PDP. Moving forward, the field for the price
    // label in Prismic should only contain the needed text/translation and no replaceable
    // characters (i.e. presently it is "From %{price}").
  });
}

export function formatAlgoliaHit(
  marketplace: Marketplace,
  productSettings: ProductSettings,
  hit: Hit
): ProductCardProps & { image: string; ageRange: string } & {
  objectID: string;
  position: number;
  queryID: string;
} {
  return {
    title: hit.title,
    description: hit.productBadgeContent,
    href: getProductUrl(marketplace, hit as Hit<AlgoliaProduct>),
    image: hit.imageURL,
    priceLabel: formatLabel(productSettings),
    formattedPrice: hit.price,
    wasPriceFormatted: hit.wasPriceFormatted,
    ageRange: formatAgeRange(productSettings, hit.minimumAge, hit.maximumAge),
    objectID: hit.objectID,
    position: hit.__position,
    queryID: hit.__queryID,
  };
}
